/**
 * Exposing intl-tel-input as a component
 */
module.exports = require("./build/js/intlTelInput");



//////////////////
// WEBPACK FOOTER
// ./~/intl-tel-input/index.js
// module id = 94
// module chunks = 16